import { FC } from "react";
import AcademicCap from "./AcademicCap";
import * as Icon from './index';
import UserIcon from "./User";
const CustomIcon : FC<{name: string; [x:string]: any;}> = (props):JSX.Element =>{
    let c_name = props.name;
    const {name, ...rest} = props;
    return(
      <div>
        {c_name ==="AcademicCap" && <Icon.AcademicCap {...rest} />}
        {c_name ==="Adjustments" && <Icon.Adjustments {...rest} />}
        {c_name ==="Archive" && <Icon.Archive {...rest} />}
        {c_name ==="APlus" && <Icon.APlus {...rest} />}
        {c_name ==="ArrowsExpand" && <Icon.ArrowsExpand {...rest} />}
        {c_name ==="ArrowRight" && <Icon.ArrowRight {...rest} />}
        {c_name ==="Balance" && <Icon.Balance {...rest} />}
        {c_name ==="Ban" && <Icon.Ban {...rest} />}
        {c_name ==="Bell" && <Icon.Bell {...rest} />}
        {c_name ==="Briefcase" && <Icon.Briefcase {...rest} />}
        {c_name ==="Calendar" && <Icon.Calendar {...rest} />}
        {c_name ==="Camera" && <Icon.Camera {...rest} />}
        {c_name ==="Cash" && <Icon.Cash {...rest} />}
        {c_name ==="SchoolHat" && <Icon.SchoolHat {...rest} />}
        
        {c_name ==="ChartPie" && <Icon.ChartPie {...rest} />}
        {c_name ==="ChartSquareBar" && <Icon.ChartSquareBar {...rest} />}
        {c_name ==="ChatAlt" && <Icon.ChatAlt {...rest} />}
        {c_name ==="Check" && <Icon.Check {...rest} />}
        {c_name ==="CheckCircle" && <Icon.CheckCircle {...rest} />}
        {c_name ==="CheckList" && <Icon.CheckList {...rest} />}
        {c_name ==="ChevronDown" && <Icon.ChevronDown {...rest} />}
        {c_name ==="ChevronLeft" && <Icon.ChevronLeft {...rest} />}
        {c_name ==="ChevronRight" && <Icon.ChevronRight {...rest} />}
        {c_name ==="ChevronUp" && <Icon.ChevronUp {...rest} />}
        {c_name ==="Clipboard" && <Icon.Clipboard {...rest} />}
        {c_name ==="ClipboardList" && <Icon.ClipboardList {...rest} />}

        {c_name ==="Clock" && <Icon.Clock {...rest} />}
        {c_name ==="Cog" && <Icon.Cog {...rest} />}
        {c_name ==="Collection" && <Icon.Collection {...rest} />}
        {c_name ==="Comment" && <Icon.Comment {...rest} />}
        {c_name ==="CreditCard" && <Icon.CreditCard {...rest} />}
        {c_name ==="CurrencyDollar" && <Icon.CurrencyDollar {...rest} />}
        {c_name ==="DeviceTablet" && <Icon.DeviceTablet {...rest} />}
        {c_name ==="DocumentText" && <Icon.DocumentText {...rest} />}
        {c_name ==="DocumentAdd" && <Icon.DocumentAdd {...rest} />}
        {c_name ==="Dot" && <Icon.Dot {...rest} />}
        {c_name ==="DotsHorizontal" && <Icon.DotsHorizontal {...rest} />}
        {c_name ==="DotsVertical" && <Icon.DotsVertical {...rest} />}
        {c_name ==="Download" && <Icon.Download {...rest} />}

        {c_name ==="Duplicate" && <Icon.Duplicate {...rest} />}
        {c_name ==="Exclamation" && <Icon.Exclamation {...rest} />}
        {c_name ==="ExclamationCircle" && <Icon.ExclamationCircle {...rest} />}
        {c_name ==="ExternalLink" && <Icon.ExternalLink {...rest} />}
        {c_name ==="Eye" && <Icon.Eye {...rest} />}
        {c_name ==="EyeOff" && <Icon.EyeOff {...rest} />}
        {c_name ==="FingerPrint" && <Icon.FingerPrint {...rest} />}
        {c_name ==="FolderOpen" && <Icon.FolderOpen {...rest} />}
        {c_name ==="Home" && <Icon.Home {...rest} />}
        {c_name ==="Image" && <Icon.Image {...rest} />}
        {c_name ==="Inbox" && <Icon.Inbox {...rest} />}

        {c_name ==="InformationCircle" && <Icon.InformationCircle {...rest} />}
        {c_name ==="Lock" && <Icon.Lock {...rest} />}
        {c_name ==="MacBook" && <Icon.MacBook {...rest} />}
        {c_name ==="Mail" && <Icon.Mail {...rest} />}
        {c_name ==="MailOpen" && <Icon.MailOpen {...rest} />}
        {c_name ==="Marks" && <Icon.Marks {...rest} />}
        {c_name ==="Menu" && <Icon.Menu {...rest} />}
        {c_name ==="Minus" && <Icon.Minus {...rest} />}
        {c_name ==="Moon" && <Icon.Moon {...rest} />}
        {c_name ==="PaymentFee" && <Icon.PaymentFee {...rest} />}
        {c_name ==="PencilAlt" && <Icon.PencilAlt {...rest} />}
        {c_name ==="Phone" && <Icon.Phone {...rest} />}
        {c_name ==="Plus" && <Icon.Plus {...rest} />}
        {c_name ==="Refresh" && <Icon.Refresh {...rest} />}
        {c_name ==="Save" && <Icon.Save {...rest} />}
        {c_name ==="Saving" && <Icon.Saving {...rest} />}

        {c_name ==="Search" && <Icon.Search {...rest} />}
        {c_name ==="Share" && <Icon.Share {...rest} />}
        {c_name ==="ShoppingBag" && <Icon.ShoppingBag {...rest} />}
        {c_name ==="ShoppingCart" && <Icon.ShoppingCart {...rest} />}
        {c_name ==="SortAscending" && <Icon.SortAscending {...rest} />}
        {c_name ==="Star" && <Icon.Star {...rest} />}
        {c_name ==="Sun" && <Icon.Sun {...rest} />}
        {c_name ==="Template" && <Icon.Template {...rest} />}
        {c_name ==="Trash" && <Icon.Trash {...rest} />}
        {c_name ==="Upload" && <Icon.Upload {...rest} />}
        {c_name ==="User" && <Icon.User {...rest} />}
        {c_name ==="UserCircle" && <Icon.UserCircle {...rest} />}

        {c_name ==="UserAdd" && <Icon.UserAdd {...rest} />}
        {c_name ==="Users" && <Icon.Users {...rest} />}
        {c_name ==="X" && <Icon.X {...rest} />}
        {c_name ==="Website" && <Icon.WebsiteIcon {...rest} />}
        {c_name ==="FaxIcon" && <Icon.FaxIcon {...rest} />}
        
      </div>
    );
  }
export default CustomIcon;